class HandlersMapManager {
  constructor() {
    this.mapServiceManager = new MapServiceManager(
      new OpenStreetMapService(),
      new MapServiceCache(),
      {
        cacheEnabled: true,
        requestDelay: 1000,
      }
    );
    this.mapLocations = new MapLocations(this.mapServiceManager, 0);
    this.mapElement = document.querySelector('map-element');
    this.mapElement.setMapService(new OpenStreetMapService());
    this.mapFilters = document.querySelector('map-filters');
    this.isFiltering = false;
    
    this.bindEvents();
  }
  
  async init() {
    this.mapElement.render();
    
    this.mapLocations.initLocations();
    await this.mapLocations.initCoordinates((location) => {
      this.mapElement.addLocationMarker(location);
    });
    
    this.fitBoundsToLocations();
  }
  
  bindEvents() {
    this.mapFilters.addEventListener('formSubmit', this.onFiltersSubmit.bind(this));
    this.mapFilters.addEventListener('formReset', this.onFiltersReset.bind(this));
    this.mapFilters.addEventListener('currentLocationClick', this.setFiltersAddressToUserLocation.bind(this));
  }
  
  async onFiltersSubmit({detail: {address, distance}}) {
    if(this.isFiltering) {
      return;
    }
    
    this.isFiltering = true;
    this.mapFilters.disableSubmit();
    
    const coordinates = MapUtil.isValidCoordinate(address)
      ? MapUtil.strToCoordinate(address)
      : await this.mapServiceManager.findCoordinatesForAddress(address);
    
    const filteredLocations = this.mapLocations.filterLocationsByDistance({
      originCoordinates: coordinates,
      distance,
    });
    
    if (filteredLocations.length) {
      this.mapFilters.setResultText(
        theme.strings.handlers.foundNLocations.replace('%num%', filteredLocations.length)
      );
      this.mapElement.fitBoundsToLocations(filteredLocations);
    } else {
      this.mapFilters.setResultText(theme.strings.handlers.noLocationsFound);
      this.fitBoundsToLocations();
    }
    
    this.isFiltering = false;
    this.mapFilters.enableSubmit();
  }
  
  onFiltersReset() {
    this.mapLocations.removeFilters();
    
    this.mapElement.fitBoundsToLocations(this.mapLocations.getLocations());
  }
  
  fitBoundsToLocations() {
    this.mapElement.fitBoundsToLocations(this.mapLocations.getLocations());
  }
  
  async setFiltersAddressToUserLocation() {
    try {
      const {latitude, longitude} = await this.mapServiceManager.getUserLocation();
      this.mapFilters.setAddress(`${latitude}, ${longitude}`);
    } catch (e) {
      console.log(e);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.handlersMapManager = new HandlersMapManager();
  window.handlersMapManager.init();
});